// Import 3rd-party dependencies
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Import project-specific dependencies
import { ChipComponent } from '@app/shared/components/chip/chip.component';
import { TaskCardComponent } from '@app/shared/components/task-card/task-card.component';
import { FavoriteSnackbarComponent } from '@app/shared/components/snackbar/favorite-snackbar.component';
import { TrendingListItemComponent } from '@app/shared/components/trending-list-item/trending-list-item.component';
import { FilterSelectComponent } from '@app/shared/components/filter-select/filter-select.component';
import { FooterComponent } from '@app/shared/components/footer/footer.component';

const components = [
  ChipComponent,
  FavoriteSnackbarComponent,
  TaskCardComponent,
  FilterSelectComponent,
  TrendingListItemComponent,
  FooterComponent
];

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatChipsModule,
    MatSnackBarModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: components,
  exports: components
})
export class HubSharedComponentsModule {}
